var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/**
 * 
 * @file Wrapper to conditionally add a tooltip
 * @author Box
 */

import * as React from 'react';
import TooltipCore from 'box-react-ui/lib/components/tooltip/Tooltip';

var Tooltip = function Tooltip(_ref) {
    var children = _ref.children,
        isDisabled = _ref.isDisabled,
        text = _ref.text,
        rest = _objectWithoutProperties(_ref, ['children', 'isDisabled', 'text']);

    if (isDisabled || !text) {
        return children;
    }

    return React.createElement(
        TooltipCore,
        _extends({ text: text }, rest),
        children
    );
};

export default Tooltip;